import React from "react";
import { withOldSiteParam } from "../utils/cacheBust";

function Deviated({ initialPage }) {
  // The way back, in this site's cache namespace. A full document navigation
  // rather than a router push, so the request actually leaves the browser --
  // and namespaced, so what answers it is this site's copy of the page rather
  // than whatever the container cached under the bare URL while it was on the
  // new site. See withOldSiteParam.
  const backTo = withOldSiteParam(initialPage);

  const handleNavigation = (e) => {
    e.preventDefault();
    window.location.href = backTo;
  };

  const handleClose = () => {
    localStorage.setItem("bannerClosed", "true");
    document.querySelector(".deviated-header").style.display = "none";
  };

  return (
    <>
      <div className="block-color-header-blue deviated-header container">
        <div className="row">
        <div className="col-11">
          <div className="pl-2">
            We noticed you've navigated away from the page you saved to your
            homescreen. Just{" "}
            <a href={backTo} onClick={handleNavigation}>
              click here
            </a>{" "}
            to go back.
          </div>
        </div>
        <div className="col-1">
          <button className="close-btn pr-2" onClick={handleClose}>
            &times;
          </button>
        </div>
        
      </div>
      </div>
    </>
  );
}

export default Deviated;
